import { render, staticRenderFns } from "./DoorOtherDamages.vue?vue&type=template&id=dcfa4aca&scoped=true"
import script from "./DoorOtherDamages.vue?vue&type=script&lang=ts"
export * from "./DoorOtherDamages.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dcfa4aca",
  null
  
)

export default component.exports